define([
    "dojo/_base/declare",
    "csi/table/New",
    "csi/wizard/ActionControllerMixin",
    "csi/xml",
    "csi/xml/Query",
    "SiteAdmin/SelectSet/SelectSetForm"
], function(declare,New,ActionControllerMixin,xml,Query) {

    return declare([New, ActionControllerMixin], {
    	getWizardViewQuery: function(/*csi.wizard.Widget*/wizard, /*csi.view.Widget*/view, /*Number*/index) {
			// summary: filter nodes by parent style
			var q = this.inherited(arguments);
			if (index == 1) {
				q = new Query();
				q.RefAttr(xml.ATTR_PARENT, xml.OP_EQUALS, this.m_urlParent);
			}
			return q;
		},

		isSelected: function() {
			return this.m_formData.getSelectedNodes().length > 0;
		},

		disableFinish: function(/*csi.wizard.Widget*/wizard, /*Content*/page, /*Number*/index) {
			return index==0 || !this.isSelected();
		},

		onNextPage: function(/*csi.wizard.Widget*/wizard,
                         /*csi.wizard.Content*/currentPage,
                         /*csi.wizard.Content*/nextPage,
                         /*Boolean*/bFinish) {
            // summary: prepare the data and pass it into the next page
            var fd = this.m_formData;
            var bRefresh = false;
            return (fd && !bFinish) ? wizard.setFormDataToPage(nextPage, fd, bRefresh) : null;
        }
    });
});
